export const TYPE_BAR = 'bar';
export const TYPE_COLUMN = 'column';
export const TYPE_REPORT = 'report';

export const TOOLTIP_POSITION = {
  place: 'right',
  placeShift: 3,
  adjustPlace: true
};
